import { DateRangeSelection, TogglePillOption } from '@/common/components';
import { Serie } from '@/modules/shared/types/DynamicBarChart.types';
import { PillIds } from '../types/PillIds';

export interface ModalParticipantsProps {
  chartData: Serie[];
  onChangeDate?: (selectedDate: DateRangeSelection) => void;
  pillOptions: TogglePillOption[];
  selectedPill: PillIds;
  viewFilter?: (filter: DateSort) => void;
}

export enum DateSort {
  DAY = 'day',
  WEEK = 'week'
}
